module.exports = __webpack_public_path__ + "res/Roboto-Black-webfont.svg?1e450b272dbb9fe1675fbf1a1612ee7c";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Black-webfont.svg
// module id = 85
// module chunks = 0